import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const UttarakhandPage = () => {
  return <DestinationTemplate destinationId="uttarakhand" />;
};

export default UttarakhandPage;
